// extracted by mini-css-extract-plugin
export var hideEditor = "_l1-2";
export var infoIcon = "_l1-3";
export var label = "_l1-1";
export var labelContainer = "_l1-0";
export var readonlyText = "_l1-4";